import { DateTime } from 'luxon'
import _ from 'lodash'

export const checkScheduleRanges = (schedule) => {
  const currentDate = DateTime.now().toFormat('yyyy-MM-dd')

  for (const day of Object.keys(schedule)) {
    const ranges = schedule[day].ranges

    for (const [index, range] of ranges.entries()) {
      const startDate = DateTime.fromISO(`${currentDate}T${range.start}`)
      const endDate = DateTime.fromISO(`${currentDate}T${range.end}`)

      // Comprueba que la hora inicial sea mayor que la hora final del rango anterior
      if (index > 0) {
        const prevEndDate = DateTime.fromISO(`${currentDate}T${ranges[index - 1].end}`)
        const diff = startDate.diff(prevEndDate).toObject().milliseconds
        if (diff <= 0) {
          return {
            day,
            rangePosition: index,
            rangeType: 'start'
          }
        }
      }

      // Comprueba que la hora final sea mayor que la hora inicial en el rango actual
      const diff = endDate.diff(startDate).toObject().milliseconds
      if (diff <= 0) {
        return {
          day,
          rangePosition: index,
          rangeType: 'end'
        }
      }
    }
  }

  return {}
}

export const getRangeSelectorClassNames = (params = {}) => {
  const { day, rangePosition, rangeType, rangeError } = params

  let classNames = 'form-control text-center datepicker_message'
  if (rangeError.day === day && rangeError.rangePosition === rangePosition && rangeError.rangeType === rangeType) {
    classNames = classNames + ' datepicker_message--error'
  }

  return classNames
}

export const parseToNumber = (HHmm) => {
  if (!HHmm) return 0
  if (typeof HHmm !== 'string') return 0

  return parseInt(HHmm.replace(/:/g, '') || 0, 10)
}

export const nextRangeStart = (HHmm) => {
  if (!HHmm) return '00:00'
  if (typeof HHmm !== 'string') return '00:00'

  const [hh, mm] = HHmm.split(':')
  const minutes = parseInt(mm, 10)

  if (minutes < 59) {
    return `${hh}:${(minutes + 1).toString().padStart(2, '0')}`
  }

  const hour = (parseInt(hh, 10) + 1).toString().padStart(2, '0')
  return `${hour}:00`
}

export const allowAddRange = (range = []) => {
  if (!Array.isArray(range)) return true
  if (!range.length) return true

  // No more 3 ranges
  if (range.length === 3) return false

  const lastRange = _.clone(range).pop()
  const endRange = lastRange?.end

  // No more range last range has 23:59
  if (parseToNumber(endRange) >= 2330) return false

  return true
}